import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {
  selectInputSelector: '[data-comp-select-filter-group-select-table]',
  filterInputSelector: '[data-comp-select-filter-group-filter-table]',
};

export default class SelectFilterGroupTable extends Component {
  static selector = '[data-comp-select-filter-group-table]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.selectInput = this.$container.querySelector(
      this.$options.selectInputSelector,
    );
    
    this.arrayFieldName = this.$container.querySelector('[data-comp-group-wrapper]').dataset.arrayFieldName;
    this.tableColumnName = this.$container.querySelector('[data-comp-group-wrapper]').dataset.tableColumnName;
    this.filterInput = this.$container.querySelector(this.$options.filterInputSelector);
    this.itemContainer = this.$container.getElementsByClassName('selected-items')[0];

    this.addedOptions = new Set();

    this.initListeners();
  }

  initListeners() {
    this.selectInput.addEventListener('change', (event) => {
      this.addNewRow(event.target.value, this.selectInput.options[this.selectInput.selectedIndex].textContent);
    });

    this.filterInput.addEventListener('keyup', (event) => {
      for (const option of this.selectInput.options) {
        option.hidden = !option.text.toLowerCase().match(event.target.value.toLowerCase());
      }
    });
  }

  addNewRow(selectedValue, selectedText) {
    if (this.addedOptions.has(selectedValue)) {
      alert('This risk owner has already been added.');
      return;
    } else {
      this.addedOptions.add(selectedValue);
    }


    let newItem = document.createElement('div');
    newItem.className = 'selected-item';

    let itemName = document.createElement('div');
    itemName.textContent = selectedText;

    let removeButtonWrapper = document.createElement('div');

    let iElement = document.createElement('i');
    iElement.className = 'fa fa-close';
    let _context = this;
    iElement.onclick = function() {
        iElement.closest('.selected-item').remove();
        _context.addedOptions.delete(selectedValue); 
    };
    
    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = this.arrayFieldName;
    input.value = selectedValue;
    newItem.appendChild(input);
    removeButtonWrapper.appendChild(iElement);
    newItem.appendChild(itemName);
    newItem.appendChild(removeButtonWrapper);

    this.itemContainer.appendChild(newItem);
  }

}
